/* SettingsSectionComponent.js */

"use strict";
const _ = require("lodash");
const EventEmitter = require("events").EventEmitter;
const Renderer = require("./SettingsSectionRenderer");

const GSO_ID = "565a65db-54e7-4461-a954-f0f38f310e19"; // if updating to name change conditional logic accordingly
const SETTINGS_SCREEN_PERM_MAP = {
    orgSettingsAccess: [
        "App.GameConsole.Section.Settings.Screens.ManageOrgs",
        "App.GameConsole.Section.Settings.Screens.ManageRoles",
        "App.GameConsole.Section.Settings.Screens.Licensing",
        "App.GameConsole.Section.Settings.Screens.CustomFields",
        "App.GameConsole.Section.Settings.Screens.ManageRet",
        "App.GameConsole.Section.Settings.Screens.Integrations",
        "App.GameConsole.Section.Settings.Screens.OSManagement",
        "App.GameConsole.Section.Settings.Screens.Zone",
        "App.GameConsole.Section.Settings.Screens.Events",
        "App.GameConsole.Section.Settings.Screens.ManageDashboards",
        "App.GameConsole.Section.Settings.Screens.ProductInformation",
        "App.GameConsole.Section.Settings.Screens.OutboundSyslog",
        "App.GameConsole.Section.Settings.Screens.Capture",
        "App.GameConsole.Section.Settings.Screens.CMDB",
        "App.GameConsole.Section.Settings.Screens.ManageConnections",
    ],
    userRead: [
        // "App.GameConsole.Section.Settings.Screens.ManageUsers"
    ],
    default: [
        "App.GameConsole.Section.Settings.Screens.ManageMyUser",
        "App.GameConsole.Section.Settings.Screens.Vaults",
    ],
    "onlyGSO.orgSettingsAccess": [
        "App.GameConsole.Section.Settings.Screens.Configuration",
        "App.GameConsole.Section.Settings.Screens.Banner",
        "App.GameConsole.Section.Settings.Screens.SingleSignOn",
    ],
    // "userWrite": "App.GameConsole.Section.Settings.Screens.ManageUsers",
    // "myUserWrite":
};

const HELP_LINKS = {
    Banner: "Settings/Global-Banner-screen.htm",
    Configuration: "Settings/Global-Configuration-screen.htm",
    ProductInformation: "Settings/Global-Product-Information-screen.htm",
    CMDBIntegration: "Settings/Organization-Integrations.htm",
    CustomFields: "Settings/Organization-Custom-Fields.htm",
    DataRetention: "Settings/Organization-Data-Retention.htm",
    Events: "Settings/Organization-Events.htm",
    Logging: "Settings/Organization-Logging-screen.htm",
    Integrations: "Settings/Organization-Integrations.htm",
    Licensing: "Settings/Organization-Licensing.htm",
    Dashboards: "Settings/Organization-Dashboards.htm",
    Organizations: "Settings/Organization-Manage-Organizations.htm",
    "Discovery&Capture": "Settings/Organization-Discovery-and-Capture-screen.htm",
    Roles: "Settings/Organization-Roles.htm",
    OSManager: "Settings/Organization-OS-Management.htm",
    Zones: "Settings/Organization-Zones.htm",
    EditMyProfile: "Settings/User-My-Profile-screen.htm",
    ManageUsers: "Settings/User-Manage-Users-screen.htm",
    // default view links for groups
    Organization: "Settings/Organization-Custom-Fields.htm",
    User: "Settings/User-My-Profile-screen.htm",
    Global: "Settings/Global-Banner-screen.htm",
    "SingleSign-On": "Settings/Global-Single%20Sign-On-screen.htm",
    Vaults: "Settings/Organization-Vaults-screen.htm",
    Connections: "Settings/Organization-Connections.htm",
};

class SettingsSectionComponent extends EventEmitter {
    constructor(logger, di, router, controlAppNav, userSession) {
        super();
        this._di = di;
        this._logger = logger;
        this._router = router;
        this._controlAppNav = controlAppNav;
        this._user = userSession.user;
        this._activeOrg = userSession.activeOrganization;

        this._setHelpLink = _.debounce(this._setHelpLink.bind(this), 1000);

        this._userSettingScreens = this._getSettingScreensForUser(); // Object.values(SETTINGS_SCREEN_PERM_MAP); //this._getSettingScreensForUser();

        this._layoutManager = this._di.createInstance("LayoutManagers.TwoTierLayout");
        this._layoutManager.setNamespaceGlobs(this._userSettingScreens);

        this._renderer = new Renderer(this, this._logger, this._layoutManager);
        /** /
        let routeInfo = this._router.getRouteDetails();
        this._subRoute = _.get(routeInfo, 'sr', "User/ManageMyUser");
        this._pageData = routeInfo.rd;

        if (this._subRoute) {
            let parsedNewRoute = this._subRoute.split("/");

            this._layoutManager.setLayoutSelections({
                groupName: parsedNewRoute[0],
                pageName: parsedNewRoute[1],
                pageData: this._pageData
            });
        } else {
            this._layoutManager.setLayoutSelections({});
        }
/**/

        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _registerListeners() {
        this._controlAppNav.on(
            "OrganizationChanged",
            (this._onActiveOrganizationChanged = this._onActiveOrganizationChanged.bind(this))
        );
        this._controlAppNav.on(
            "ShutdownCurrentSection",
            (this._onShutDownSettingsSection = this._onShutDownSettingsSection.bind(this))
        );
        this._router.onPathTokenChange(
            "sr",
            (this._onSRTokenChanged = this._onSRTokenChanged.bind(this))
        );
    }

    _unregisterListeners() {
        this._controlAppNav.removeListener(
            "OrganizationChanged",
            this._onActiveOrganizationChanged
        );
        this._controlAppNav.removeListener(
            "ShutdownCurrentSection",
            this._onShutDownSettingsSection
        );
        this._router.removePathTokenChangeListener("sr", this._onSRTokenChanged);
    }

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS     */
    /* START PUBLIC COMPONENT MODEL METHODS    */
    /*******************************************/

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();

        let promArr = [];
        promArr.push(this._renderer._shutdown());

        return Promise.all(promArr).then(
            () => {
                this._steve = undefined;
                this._logger = undefined;
                this._renderer = undefined;
                this._router = undefined;
                this._controlAppNav = undefined;
                this._user = undefined;
                this._userSettingScreens = undefined;
            },
            (err) => {
                this._logger.warn("Error shutting down Settings section", err);
            }
        );
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* Start Section Mgr API METHODS           */
    /*******************************************/

    shutDown() {
        return this.shutdown();
    }

    _onSRTokenChanged(newPathToken, oldPathToken, fullData) {
        // console.log("Subroute Changed!",oldPathToken, newPathToken);
        let selectionOptions = {};
        let rd = _.get(fullData, "routeDetails.newRouteDetails.rd", false);
        if (rd) {
            selectionOptions.pageData = rd;
        }

        if (newPathToken !== oldPathToken) {
            if (newPathToken) {
                let parsedNewRoute = newPathToken.split("/");
                selectionOptions.groupName = parsedNewRoute[0];
                selectionOptions.pageName = parsedNewRoute[1];
            }
        }
        this._layoutManager.renderer.rootElement.className = selectionOptions.pageName;
        this._setHelpLink(selectionOptions);
        this.emit("RouteUpdated", selectionOptions);
    }

    _onActiveOrganizationChanged(activeOrg, previousOrg) {
        // jshint ignore:line
        this.emit("OrganizationChanged", activeOrg, previousOrg);
        if ((previousOrg && previousOrg.id === GSO_ID) || activeOrg.id === GSO_ID) {
            this._layoutManager.setNamespaceGlobs(this._getSettingScreensForUser(activeOrg.id));
            this._layoutManager.emit("NamespaceGlobsChanged");
        }
    }

    _onShutDownSettingsSection() {
        this._layoutManager.renderer._pageComponent.shutdown();
    }

    updateRoute(routeOptions) {
        this._router.updateRouteInfo(routeOptions);
    }

    /*******************************************/
    /* END Section Mgr API METHODS             */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    _getSettingScreensForUser(orgId) {
        // console.log(this._user.authorizedTenants);
        const authorizedOrgs = Object.keys(this._user.authorizedTenants);
        const activeOrg = orgId || this._activeOrg.id;
        let isGSO = false;
        if (activeOrg === GSO_ID && authorizedOrgs.includes(activeOrg)) {
            isGSO = true;
        }
        let settingsScreensList = [];
        settingsScreensList = settingsScreensList.concat(SETTINGS_SCREEN_PERM_MAP.default);
        if (this._user.authorizedActions.indexOf("orgSettingsAccess") >= 0) {
            settingsScreensList = settingsScreensList.concat(
                SETTINGS_SCREEN_PERM_MAP.orgSettingsAccess
            );
            if (isGSO) {
                settingsScreensList = settingsScreensList.concat(
                    SETTINGS_SCREEN_PERM_MAP["onlyGSO.orgSettingsAccess"]
                );
            }
        }
        if (this._user.authorizedActions.indexOf("userRead") >= 0) {
            settingsScreensList = settingsScreensList.concat(SETTINGS_SCREEN_PERM_MAP.userRead);
        }
        return settingsScreensList;
    }

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    getRouteInformation() {
        let routeInfo = this._router.getRouteDetails();
        let subRoute = _.get(routeInfo, "sr", "Global/ProductInformation");
        return {
            subRoute,
            pageData: routeInfo.rd,
        };
    }

    _setHelpLink(section) {
        const _helpIcon = document.getElementsByClassName("glu-nav__item help-icon")[0];
        const _link = HELP_LINKS[section.pageName]
            ? HELP_LINKS[section.pageName]
            : HELP_LINKS[section.groupName];
        if (_helpIcon && _link) {
            _helpIcon.setAttribute("help-link", _link);
        }
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}

module.exports = SettingsSectionComponent;
module.exports.$inject = [
    "$teve.logger",
    "$teve.di",
    "$teve.router",
    "$teve.controlAppNav",
    "$teve.userSession",
];
